import styled from "styled-components";

const ErrorText = styled.div`
  color: #d02e1d;
`;
export default ErrorText;
